var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { padding: "30px 40px 50px 40px" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "boton_crear" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "icon",
                              staticStyle: {
                                "background-color": "rgb(255, 108, 0)",
                                "border-color": "rgb(255, 108, 0)",
                                "padding-right": "20px",
                                display: "block",
                                margin: "0 0 0 auto"
                              },
                              on: { click: _vm.editar }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "color-blanco",
                                  staticStyle: { color: "white" }
                                },
                                [_vm._v("Guardar")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "General" } },
                        [
                          _vm._t("prependInformacionGeneral"),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.serienumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.serienumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.serienumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.serienumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.prefijo.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.prefijo.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.prefijo,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.prefijo.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simmovil.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simmovil.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simmovil,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simmovil.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.telconame.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.telconame.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.telconame,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.telconame.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.planSinDatos == false
                                ? _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.telcoplanname.label,
                                      items: _vm.planlist,
                                      "item-text": "telcoplanname",
                                      "item-value": "telcoplanid"
                                    },
                                    model: {
                                      value: _vm.formFields.telcoplanname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.telcoplanname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.telcoplanname.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.planSinDatos
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.telcoplanname.label
                                    },
                                    model: {
                                      value: _vm.formFields.telcoplanname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.telcoplanname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.telcoplanname.value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label:
                                    _vm.formFields.simprovision_fecha.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value:
                                    _vm.formFields.simprovision_fecha.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simprovision_fecha,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.simprovision_fecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simtamanio.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simtamanio.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simtamanio,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simtamanio.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.apnSinDatos == false
                                ? _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.simapn.label,
                                      items: _vm.apnlist,
                                      "item-text": "telcoapnname",
                                      "item-value": "telcoapnid"
                                    },
                                    model: {
                                      value: _vm.formFields.simapn.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.simapn,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.simapn.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.apnSinDatos
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.simapn.label,
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.formFields.simapn.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.simapn,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.simapn.value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simingresonumero.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simingresonumero.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simingresonumero,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formFields.simingresonumero.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.formFields.simingresofecha.label,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.simingresofecha.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.simingresofecha,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.simingresofecha.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.estadoSinDatos == false
                                ? _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.configvalor.label,
                                      items: _vm.estadolist,
                                      "item-text": "configvalor",
                                      "item-value": "configid"
                                    },
                                    model: {
                                      value: _vm.formFields.configvalor.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.configvalor,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.configvalor.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.estadoSinDatos
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.configvalor.label
                                    },
                                    model: {
                                      value: _vm.formFields.configvalor.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.configvalor,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "formFields.configvalor.value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs4: "", sm4: "", md4: "" } },
                            [
                              _vm.ubicacionSinDatos == false
                                ? _c("v-combobox", {
                                    attrs: {
                                      label: _vm.formFields.tipoubicaname.label,
                                      items: _vm.ubicacionList,
                                      "item-text": "tipoubicaname",
                                      "item-value": "tipoubicaid"
                                    },
                                    model: {
                                      value: _vm.formFields.tipoubicaname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoubicaname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tipoubicaname.value"
                                    }
                                  })
                                : _vm._e(),
                              _vm.ubicacionSinDatos
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: _vm.formFields.tipoubicaname.label
                                    },
                                    model: {
                                      value: _vm.formFields.tipoubicaname.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.tipoubicaname,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.tipoubicaname.value"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }